import type { CustomCell, CustomRenderer } from '@glideapps/glide-data-grid'
import { getMiddleCenterBias, GridCellKind } from '@glideapps/glide-data-grid'

export interface Option {
  label: string
  value: string
}

type DropdownCellGetSuggestionsFn = (text: string) => Promise<Option[]>
export interface DropdownCellProps {
  readonly choices?: Option[]
  readonly update?: DropdownCellGetSuggestionsFn
  readonly kind: 'dropdown-cell'
  readonly value: Option | null
  readonly allowCustomValues?: boolean
  readonly emptyOption?: boolean
}

export type DropdownCell = CustomCell<DropdownCellProps>

export const emptyDropdownCellValue: Option = {
  label: '',
  value: '',
}

// Note: This is a simplified dropdown that only displays value
// For full editing support, you'd need to implement a custom editor component
export const dropdownCellRenderer: CustomRenderer<DropdownCell> = {
  draw: (args, cell) => {
    const { ctx, theme, rect } = args
    const { value } = cell.data

    ctx.fillStyle = theme.textDark
    ctx.fillText(
      value?.label ?? '',
      rect.x + 8,
      rect.y + rect.height / 2 + getMiddleCenterBias(ctx, theme),
    )

    return true
  },
  isMatch: (c): c is DropdownCell => (c.data as DropdownCellProps).kind === 'dropdown-cell',
  kind: GridCellKind.Custom,
  onPaste: (value, data) => ({
    ...data,
    value: value
      ? {
          label: value,
          value,
        }
      : null,
  }),
}
